<template>
	<!-- 结算单 - son -->
	<div class="table">
		<el-table
		  :stripe="true" :border="false"
		  :data="tableData"
		  :style="{ width: w + 'px' }" 
		>
	    <el-table-column label="随货单号" width="140">
			<template slot-scope="scope">
				<span style="color: #00aaff;">{{ scope.row.serialNumber }}</span>
			</template>
		</el-table-column>
		<!-- tag -->
	    <el-table-column label="状态" prop="status" align="center" sortable> 
			<template slot-scope="scope">
				<el-tag
				  :type="scope.row.status == 1 ? 'primary' : 'info'"
				  disable-transitions>{{ scope.row.status == 1 ? '已结算' : '未结算' }}</el-tag>
			</template>
		</el-table-column>
	    <el-table-column label="类型" prop="types" align="center">
		<template slot-scope="scope">
			<el-tag
			  :type="scope.row.types == 1 ? 'primary' : 'info'"
			  disable-transitions>{{ scope.row.types == 1 ? '已结算' : scope.row.types == 2 ? '未结算' : scope.row.types == 3 ? '已作废' : '无状态' }}</el-tag>
		</template>
		</el-table-column>
	    <el-table-column label="库房" prop="store" width="120" align="center"> </el-table-column>
		<el-table-column label="供应商" prop="supplier" width="180" align="center"> </el-table-column>
		<el-table-column label="品种数" prop="variety" align="center"> </el-table-column>
		<el-table-column label="数量" prop="numbers" align="center"> </el-table-column>
		<el-table-column label="含税金额" prop="actualAmount" align="center"> </el-table-column>
		<el-table-column label="不含税金额" prop="noTaxInclusiveAmount" align="center"> </el-table-column>
		<el-table-column label="生产批号" prop="batchNumber" align="center"> </el-table-column>
		<el-table-column label="进货价" prop="buyingPrice" align="center"> </el-table-column>
		<el-table-column label="制单人" prop="submitPeople" align="center"> </el-table-column>
		<el-table-column label="完成日期" prop="submissionTime" width="140" align="center"> </el-table-column>
		<el-table-column label="操作" fixed align="center">
		  <template slot-scope="scope">
		    <el-button size="mini" @click="handleEdit(scope.row)" :disabled="scope.row.status == 1 ? true : false">编辑</el-button>
		  </template>
		</el-table-column>
		</el-table>
		<!-- 编辑模态框 -->
		<div class="model">
			<el-dialog
			  title="结算状态"
			  :visible.sync="dialogVisible"
			   width="60%"
			  :before-close="handleClose">
			  <!-- head -->
			  <div class="head">
				   <div class="icon"><i class="el-icon-star-on" style="font-size: 20px;color: #ffaa00;"></i></div>
			  </div>
			  <!-- Collapse -->
			  <div class="Collapse">
				  <el-collapse v-model="activeNames" @change="handleChange">
					  <!-- 默认展开 -->
				    <el-collapse-item title="基本信息" name="1">
						<!-- collTable -->
				      <div class="collTable">
						<!-- 列表 -->
						<el-table 
						:stripe="true" 
						:data="edtable" 
						:style="{ width: w + 'px' }" 
						@select="handleSelectionChange"
						row-key="id" 
						border 
						@row-dblclick="dbclick" 
						:cell-class-name="tableCellClassName" 
						:row-style="{height:'40px'}"
						>
							<el-table-column label="随货单号" width="140" sortable>
								<template slot-scope="scope">
									<span style="color: #00aaff;">{{ scope.row.serialNumber }}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作人" prop="submitPeople" width="80" align="center"></el-table-column>
							<el-table-column label="审核人" prop="username" width="80" align="center">
								<template slot-scope="scope">
								  <span>{{ username }}</span>
								</template>
							</el-table-column>
							<!-- 修改结算状态 -->
							<el-table-column prop="valueOpen" label="我要结算" width="200" align='center'>
							<template slot-scope="scope">
								<el-switch
								  v-model="valueOpen"
								  active-color="#13ce66"
								  inactive-color="#ff4949"
								  :ref="scope.row.index + ',' + scope.column.index"
								  v-if="scope.row.index + ',' + scope.column.index == currentCell"
								  @blur="hideInput"
								  >
								</el-switch>
								<!-- <span>{{ scope.row.valueOpen }}</span> -->
								<el-switch  
								 v-else
								  v-model="scope.row.valueOpen"
								  :disabled="disabled"
								  active-color="#13ce66"
								  inactive-color="#ff4949"
								  >
								</el-switch>
							</template>
							</el-table-column>
							<el-table-column label="结算清单提交时间" prop="submissionTime" align="center" width="180"></el-table-column>
							<!-- status= 1 -->
							<el-table-column label="结算状态" prop="settlementStatus" align="center">
								<template slot-scope="scope">
									<!-- <el-tag
									  :type="scope.row.settlementStatus === 1 ? 'primary' : 'info'"
									  disable-transitions>{{ scope.row.settlementStatus == 1 ? '已结算' : '未结算' }}</el-tag> -->
									  <el-steps :space="200" :active="active" finish-status="success">
									    <el-step title="未结算"></el-step>
									    <el-step title="已结算"></el-step>
									  </el-steps>
								</template>
							</el-table-column>
							
						</el-table>
					</div>
				    </el-collapse-item>
				    <el-collapse-item title="供应商相关" name="2">
				        <!-- 列表 -->
				        <el-table :stripe="true" :border="true" :data="edtable" :style="{ width: w + 'px' }" >
				        	<el-table-column label="供应商名称" width="100" sortable>
				        		<template slot-scope="scope">
				        			<span style="color: #00aaff;">{{ scope.row.supplier }}</span>
				        		</template>
				        	</el-table-column>
				        	<el-table-column label="入库类型" prop="types" align="center"></el-table-column>
							<el-table-column label="入库门店" prop="store" align="center"></el-table-column>
				        </el-table>
				    </el-collapse-item>
					
				    <el-collapse-item title="收支明细" name="3">
				       <!-- 列表 -->
				       <el-table :stripe="true" :border="true" :data="edtable" :style="{ width: w + 'px' }" >
				       	<el-table-column label="采购入库ID" prop="purchaseId" align="center"></el-table-column>
				       	<el-table-column label="本次采购入库数量" width="80" sortable>
				       		<template slot-scope="scope">
				       			<span style="color: #00aaff;">{{ scope.row.numbers }}</span>
				       		</template>
				       	</el-table-column>
				       	<el-table-column label="实际金额" prop="actualAmount" align="center"></el-table-column>
						<el-table-column label="实际税额" prop="actualTaxAmount" align="center"></el-table-column>
						<el-table-column label="总金额" prop="totalPrice" align="center"></el-table-column>
				       </el-table>
				    </el-collapse-item>
					
				    <el-collapse-item title="更多信息" name="4">
				       <!-- 列表 -->
				       <el-table :stripe="true" :border="true" :data="edtable" :style="{ width: w + 'px' }" >
				       	<el-table-column label="采购入库ID" prop="purchaseId" align="center"></el-table-column>
				       	<el-table-column label="本次采购入库数量" width="80" sortable>
				       		<template slot-scope="scope">
				       			<span style="color: #00aaff;">{{ scope.row.numbers }}</span>
				       		</template>
				       	</el-table-column>
				       	<el-table-column label="审核人" prop="auditPeople" align="center"></el-table-column>
						<el-table-column label="审核时间" prop="auditTime" align="center"></el-table-column>
						<el-table-column label="品种" prop="variety" align="center"></el-table-column>
				       </el-table>
				    </el-collapse-item>
				  </el-collapse>
				  
			  </div>
			  <span slot="footer" class="dialog-footer">
			    <el-button size="mini" type="primary" @click="sendtoOpp">确 定</el-button>
			    <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
			  </span>
			</el-dialog>
		</div>
		<!-- 分页 -->
		<el-pagination
		@size-change="handleSizeChange"
		@current-change="handleCurrentChange"
		:current-page="pageNum"
		:page-sizes="[10, 20, 30]"
		:page-size="pageSize"
		layout="total, sizes, prev, pager, next, jumper"
		:total="totalSize"
		background
		>
		</el-pagination>
		<!-- <div>父组件传入的参数：{{ status }}</div> -->
	</div>
</template>

<script>
	// 接口相关
	import { 
		selectAll,selectSupplier,StatusAndSupplier,
		settlement
	 } from "@/api/PSI";
	// selfs / js
	import filesTable from '../../external/comment/filesTable.js'
	  export default {
		  components: {
		  	filesTable
		  },
		  props: {
		      status: {
		        type: String,
		      }
		    },
		data() {
		  return {
			    w: document.body.clientWidth - 160, //表格的宽度
			    // bool
				valueOpen: true,
				disabled: true,
				StatusDialogVisible: false,
				dialogVisible: false,
				dialog: false,
				// str
				username: '',//当前操作审核人
				ValueOpenInput: '',
				search: '',
				inputssss:'',
				direction: 'rtl',
				currentCell: null,
				// num
				edindex:0,
				active: 1,
				pageNum: 1, //当前页currentPage
				totalSize: 10, //总条数
				pageSize: 10,
				// arr
				tableData: [],
				headerBtn:[
				 // { back:"back", title:"返回", type:"primary" },
				 { close:"close", title:"关闭", type:"info", icon:"el-icon-close" },
				 { editHistory:"editHistory", title:"修改历史", type:"primary", icon:"el-icon-time" },
				 { save:"save", title:"保存", type:"primary", icon:"el-icon-thumb" },
				 { saveClose:"saveClose", title:"保存并关闭", type:"primary", icon:"el-icon-folder" },
				],
				filesTable: [],
				activeNames: ['1'],
				edtable: [],
				//login yz pwd
				formData: {
				  userName: "",
				  password:"",
				  // userGroup:"",
				},
		  }
		},
		created() {
			window.addEventListener("resize", this.resizeHandle);
			
		},
		mounted() {
			// 从localStorage中获取字符串并将其转换回JSON对象
			this.userinfo = JSON.parse(localStorage.getItem('userInfo'))
			// console.log(this.userinfo);
			this.username = this.userinfo.userName
			//调用获取数据列表函数
			this.loadData();
		},
		methods: {
			//列表
			async loadData(parentMsg) {
				// console.log(parentMsg,'p传过来的');
				let rs = await StatusAndSupplier({
					status: parentMsg,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
			
				let { total, data } = rs;
				// console.log(rs);
				this.total = total;
				this.totalSize = rs.data.totalSize
				this.pageSize = rs.data.pageSize
				this.tableData = rs.data.content;
				console.log(this.tableData.types);
			},
			handSelected(){
				console.log(this.OptionsValue3);
			},
			// 步骤
			next() {
				this.active ++
				if (this.active ++ > 2) this.active = 0;
			  },
			  // edit
			handleEdit(row) {
			 this.dialogVisible = !this.dialogVisible
			 this.edtable.push(row);
			// this.edindex = row.index
			// console.log(this.edtable)
		   },
			//绑定横向和竖向Index才能确定是哪个单元格
			tableCellClassName({row, column, rowIndex, columnIndex}){
				row.index = rowIndex;
				column.index = columnIndex;
				// console.log(row.index + ',' + column.index);
			},
			// 获得双击单元格的横竖Index将其拼接成唯一字符串判断并赋给currentCell
			dbclick(row,column) {
				this.currentCell = row.index + ',' + column.index;
				// console.log(column.index);
				// 必须setTimeout 点击时input才刚被v-if显示不然拿不到dom
				setTimeout(() => {
					if(column.index == 3 ){
						// console.log('支持');
						// 双击后自动获得焦点
						this.$refs[row.index + ',' + column.index].focus();
						// 开始验证
						this.StatusDialogVisible = true;
						console.log(this.StatusDialogVisible);
						this.dialog = true;
						// 步骤
						if(this.StatusDialogVisible === true){
							if (this.active++ > 2) this.active = 0;
							this.edtable.map(v =>{ v.status = 1; return v })
						}else{
							this.active = 1;
						}
					}else{
						// console.log('不支持');
					}
				})
			},
			// 提交按钮
			async sendtoOpp(){
				let result = await settlement(this.edtable)
				console.log(result.data);
				if(result.code === 200){
					this.$message({
					  message: result.data,
					  type: 'success'
					});
					this.$router.go(0)
				}else{
					this.$message.error('fail');
				}
			},
			// 当input失焦时隐藏input
			hideInput(){
				this.currentCell = null;
				// let sub = this.edtable[this.edtable.length-1].ValueOpenInput
			},
			handleSelectionChange(val) {
				console.log(val);
			},
		   // close
		   handleClose(done) {
			   this.edtable=[];
			   this.disabled = true;
			   done();
			},
			 // change
			handleChange(val) {
				console.log(val);
			  },
			  // edit
		    edhandchilck(i){
				// i event
				switch(i){
					case 0:
					// 处理索引0的逻辑
					this.dialogVisible = false
					break;
					case 1:
					// 处理索引1的逻辑
					this.$confirm('修改历史：敬请期待')
					 .then(_ => {})
					 .catch(_ => {});
					break;
					case 2:
					// 处理索引2的逻辑
					console.log('2')
					break;
				}
		    },
			  // delete
			handleDelete(index, row) {
			    console.log(index, row)
		   },
		   //分页
		   //每页条数改变触发
		   handleSizeChange(val) {
		   console.log(`每页 ${val} 条`);
		   this.pageNum = val;
		   this.loadData();
		   },
		   //当前条数改变触发
		   handleCurrentChange(val) {
		   console.log(`当前页: ${val}`);
		   this.pageNum = val;
		   this.loadData();
		   },
		   //窗口触发函数
		   resizeHandle() {
		   	console.log("窗口发生改变");
		   	this.w = document.clientWidth - 160;
		   },
		}
		
	  }
</script>

<style lang="less" scoped>
.table{
	margin-top: 12px;
	font-size: 12px;
	
	/* 穿透 */
	/deep/ .el-step__main{
		white-space: inherit;
		padding: 8px;
	}
	::v-deep .el-table th.el-table__cell>.cell{
		font-size: 12px;
	}
	/deep/ .el-steps--simple{
		width: 100%;
	}
	/deep/ .el-table td.el-table__cell div{
		display: flex !important;
		justify-content: center;
		align-items: center;
		font-size: 12px;
	}
	/deep/ .el-table--border .el-table__cell {
		text-align: center !important;
	}
}
.head{
	display: flex;
	justify-content: space-between;
	margin-bottom: 12px;
}
.collTable{
	table{
		// display: flex;
		width: 100%;
		height: 100px;
		border-collapse: collapse;
		background-color: #efefef;
		tr{
			border: 0;
		}
		td{
			border: 1px solid #ddd;
			font-weight: bold;
			span{
			
				font-weight: 400;
			}
		}
	}
}
</style>
